<template>
  <div>Página não encontrada...</div>
</template>

<script>
export default {
  created() {
    this.$store.commit("pageHasLoaded");
  },
};
</script>

<style>
</style>